const parseBoolean = (value?: string) => (value || "").toLowerCase() === "true";

export const isAuthDisabled =
  parseBoolean(process.env.REACT_APP_DISABLE_AUTH) ||
  process.env.NODE_ENV === "test";
